import { io } from 'socket.io-client';

import socketBaseUrl from './socketBaseUrl';

const socketStorePolicies = io(`${socketBaseUrl}/store-policies-progress`, {
  transports: ['websocket'],
  autoConnect: false,
});

export default socketStorePolicies;
